import { types, flow } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';
import { pick } from 'lodash';

import CreditCardSummary from './CreditCardSummary';

export default types
  .model('CreditCardsPaginator', {
    isLoading: false,
    error: types.maybeNull(types.string),
    page: 1,
    last_page: 0,
    count: 3,
    total: 0,

    credit_cards: types.array(CreditCardSummary),
    email: '',
  })
  .views(self => ({
    get hasMorePages() {
      return self.page < self.last_page;
    },
  }))
  .actions(self => ({
    load: flow(function* load(replace = false) {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-credit-cards-list', null, {
            email: self.email,
            ...pick(self, ['page', 'count']),
          });
          self.last_page = response.data.last_page;
          self.total = response.data.total;

          if (replace) {
            self.credit_cards = response.data.data;
          } else {
            response.data.data.forEach(instance => self.credit_cards.push(instance));
          }
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
    prevPage() {
      if (self.page > 1) {
        self.page--;
        self.load(true);
      }
    },
    nextPage() {
      if (self.page < self.last_page) {
        self.page++;
        self.load(true);
      }
    },
    loadMore() {
      if (self.page < self.last_page) {
        self.page++;
        self.load();
      }
    },
  }));
